<template >
  <v-container :key="componentKey">
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="4"
        md="3"
        v-for="(item, key) in items"
        :key="key"
        :class="classPadding"
      >
        <v-checkbox
          :value="item.code"
          :class="classPadding"
          :label="item.descript"
          v-model="selected"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
        <v-text-field autocomplete="off" label="Description" :class="classPadding" v-model="model.desc"></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
        <v-btn color="primary" :class="classPadding" icon @click="add" :loading="isSaving">
          <v-icon>mdi-plus</v-icon>
        </v-btn>&nbsp;
        <v-btn color="error" :class="classPadding" icon @click="deleteInfo" :loading="isDeleting">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// const this.table = "tbl_DOLESkin",
import EventBus from "../../../../../events/eventBus";
const API_ENDPOINT = "/api/dole";
export default {
  props: ["table"],
  data: () => ({
    items: [],
    classPadding: "my-0 py-0",
    selected: [],
    model: {},
    isSaving: false,
    isDeleting: false,
    componentKey: 0
  }),
  methods: {
    getAll() {
      this.$axios
        .get(`${API_ENDPOINT}/${this.table}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.toast.error(response.data.message);
        })
        .finally(() => {
          this.componentKey++;
        });
    },
    // toggleExamType(examType) {
    //   if (this.selected.includes(examType)) {
    //     // Removing the examType
    //     this.selected.splice(this.selected.indexOf(examType), 1);
    //   } else {
    //     // Adding the examType
    //     this.selected.push(examType);
    //   }
    // },
    add() {
      this.isSaving = true;
      this.model.tableName = this.table;
      this.$axios
        .post(`${API_ENDPOINT}`, this.model)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    deleteInfo() {
      this.isDeleting = true;
      this.$axios
        .post(`${API_ENDPOINT}/delete/${this.table}`, this.selected)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isDeleting = false;
        });
    },
    reset() {
      this.getAll();
      this.componentKey++;
      this.selected = [];

      this.model = {};
    }
  },
  mounted() {
    this.getAll();
  },
  watch: {
    selected(val) {
      EventBus.$emit(`${this.table}`, val);
    }
  }
};
</script>